// Copyright (c) 2016 Deere & Company

import PinsNotRegistered from '../../../reports/pins-not-registered/state-connector';

export default {
    component: PinsNotRegistered,
    name: 'PINS_NOT_REGISTERED',
    path: 'pins-not-registered'
};



// WEBPACK FOOTER //
// ./src/routes/products/reports/pins-not-registered.js